import * as React from "react";
import "reflect-metadata";
import { Routes } from "./components/Routes";
import { useState, useEffect } from "react";
import * as fb from "./firebase";
import * as sentry from "./lib/sentry";
import firebase from "firebase";
import { agent, initAgent } from "./agent";
import { myDataActions } from "./store/myData";
import { paymentActions } from "./store/payment";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "./store";
import { UserStatus } from "./generated/lib-domain/user";
import { CommonAPIErrors } from "./generated/lib-domain/apiErrors";
import { smartAlert } from "./lib/confirm-alert";

const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const shouldLoad = useSelector(
        (state: AppState) => state.myData.shouldLoad
    );
    const myUser = useSelector((state: AppState) => state.myData.user);
    const shouldRegister = useSelector(
        (state: AppState) => state.myData.shouldRegister
    );
    const setAgentHeader = async (user: firebase.User | null) => {
        if (!user) {
            return;
        }
        const token = await user.getIdToken();
        if (!token) {
            return;
        }
        agent.httpClient.setHeaders({
            Authorization: "bearer " + token
        });
    };
    useEffect(() => {
        initAgent();
        fb.initFirebase();
        fb.onIdTokenChange(setAgentHeader);
    }, []);

    useEffect(() => {
        if (!shouldLoad) return;
        (async () => {
            const fireUser = await fb.getFirebaseUser();
            if (fireUser) {
                sentry.setUser(fireUser.uid);
            }
            await setAgentHeader(fireUser);
            try {
                const user = await agent.getMyUser();
                if (!user) {
                    dispatch(myDataActions.myDataShouldRegisterSet(true));
                    dispatch(myDataActions.myDataIsJustLoggedIn(true));
                    dispatch(myDataActions.myDataShouldLoadSet(false));
                    setIsLoading(false);
                    return;
                }
                dispatch(myDataActions.myDataUserSet(user));
                if (
                    user.status === UserStatus.Active ||
                    user.status === UserStatus.Created
                ) {
                    const paymentStatus = await agent.getPaymentStatus();
                    dispatch(paymentActions.paymentStatusSet(paymentStatus));
                }
                dispatch(myDataActions.myDataIsJustLoggedIn(true));
            } catch (error) {
                console.error(error);
                if (
                    error.errorCode === CommonAPIErrors.FORCED_LOGOUT.errorCode
                ) {
                    await fb.logout();
                    await smartAlert(CommonAPIErrors.FORCED_LOGOUT.message);
                    location.href = "/";
                }
            }
            dispatch(myDataActions.myDataShouldLoadSet(false));
            setIsLoading(false);
        })();
    }, [shouldLoad]);

    if (isLoading) {
        return <div>loading</div>;
    }

    return <Routes user={myUser} shouldRegister={shouldRegister} />;
};

export default App;
